import { render } from "./caseB.vue?vue&type=template&id=02303bd4&scoped=true"
import script from "./caseB.vue?vue&type=script&lang=js"
export * from "./caseB.vue?vue&type=script&lang=js"

import "./caseB.vue?vue&type=style&index=0&id=02303bd4&scoped=true&lang=css"

import exportComponent from "C:\\WorkSpace\\webapp\\vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02303bd4"]])

export default __exports__